<template>
  <div class="ml-3">
    <el-form
      ref="form"
      :model="layout"
    >
      <h2>Application Layout</h2>
      <el-form-item
        label="Sidebar"
        prop="sidebar"
      >
        <el-radio-group
          v-model="layout.sidebar"
          size="small"
        >
          <el-radio-button label="floating">
            Floating
          </el-radio-button>
          <el-radio-button label="collapsed">
            Collapsed
          </el-radio-button>
          <el-radio-button label="expanded">
            Expanded
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="Home Page"
        prop="central"
      >
        <el-select
          v-model="layout.central"
          placeholder="Central"
          class="w-80"
          size="small"
          filterable
        >
          <el-option-group
            v-for="(route, index) in routes"
            :key="index"
            :label="route.label"
          >
            <el-option
              v-for="option in route.options"
              :key="option.route"
              :label="option.label"
              :value="option.route"
              :disabled="option.disabled"
            >
              <span style="float: left">{{ option.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 12px">{{ route.label }}</span>
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Chart Cache Time (Hours)"
        prop="cacheTime"
      >
        <el-input-number
          v-model="layout.cacheTime"
          placeholder="Hours"
          :min="1"
          size="small"
        />
      </el-form-item>
      <el-form-item
        label="Consignment Page Preferences"
        prop="consignmentPagePreferences"
      >
        <el-checkbox-group v-model="layout.consignmentPagePreferences">
          <el-checkbox
            v-for="m in consignmentPage"
            :key="m"
            :label="m"
          >
            {{ $filters.titleize(m) }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item
        label="Consignment Link Hover Preview"
        prop="consignmentLinkPopoverEnabled"
      >
        <el-switch
          v-model="layout.consignmentLinkPopoverEnabled"
          active-text="Enabled"
          inactive-text="Disabled"
        />
      </el-form-item>

      <el-form-item
        label="Global Keyboard Navigation Shortcuts"
        prop="keyboardShortcutsEnabled"
      >
        <el-switch
          v-model="layout.keyboardShortcutsEnabled"
          active-text="Enabled"
          inactive-text="Disabled"
        />
      </el-form-item>

      <el-form-item
        label="Table Size"
        prop="tableSize"
      >
        <el-select
          v-model="layout.tableSize"
          placeholder="Table Size"
          class="w-40"
          size="small"
        >
          <el-option
            label="Default"
            value="default"
          />
          <el-option
            label="Mini"
            value="mini"
          />
          <el-option
            label="Small"
            value="small"
          />
          <el-option
            label="Medium"
            value="medium"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { READ } from '@/plugins/user'

export default {
  props: {
    layout: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      consignmentPage: [ 'all', 'header', 'information', 'items', 'tracking', 'tracking errors', 'pricing and margin', 'manifest pricing', 'quoted pricing' ],
      routes: [
        {
          label: 'Customer Service',
          options: [
            {
              label: 'Dashboard',
              route: 'customerservice',
              disabled: this.$user.cannot(READ, 'menu_customerservice')
            },
            {
              label: 'Accounts',
              route: 'customerservice-accounts',
              disabled: this.$user.cannot(READ, this.$sdk.account) || this.$user.cannot(READ, 'menu_customerservice')
            },
            {
              label: 'Pickups',
              route: 'customerservice-pickups',
              disabled: this.$user.cannot(READ, this.$sdk.pickup) || this.$user.cannot(READ, 'menu_customerservice')
            },
            {
              label: 'Campaigns',
              route: 'customerservice-campaigns',
              disabled: this.$user.cannot(READ, 'notification_template') || this.$user.cannot(READ, 'menu_customerservice')
            },
            {
              label: 'Enquiries',
              route: 'customerservice-enquiries',
              disabled: this.$user.cannot(READ, 'enquiry_enquirymain') || this.$user.cannot(READ, 'menu_customerservice')
            }
          ]
        },
        {
          label: 'Manage',
          options: [
            {
              label: 'Accounts',
              route: 'manage',
              disabled: this.$user.cannot(READ, this.$sdk.account) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Users',
              route: 'manage-users',
              disabled: this.$user.cannot(READ, this.$sdk.profile) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Assets',
              route: 'manage-assets',
              disabled: this.$user.cannot(READ, this.$sdk.asset) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Carriers',
              route: 'manage-carriers',
              disabled: this.$user.cannot(READ, this.$sdk.carrier) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'EDI',
              route: 'manage-edi',
              disabled: this.$user.cannot(READ, 'edi') || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Rate Cards',
              route: 'manage-ratecards',
              disabled: this.$user.cannot(READ, this.$sdk.ratecard) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Fuel Levies',
              route: 'manage-fuellevies',
              disabled: this.$user.cannot(READ, this.$sdk.fuel) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Surcharges',
              route: 'manage-surcharges',
              disabled: this.$user.cannot(READ, this.$sdk.ratesurcharge) || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Zones',
              route: 'manage-zones',
              disabled: this.$user.cannot(READ, 'dictionary_zone') || this.$user.cannot(READ, 'menu_manage')
            },
            {
              label: 'Scheduled Pickups',
              route: 'manage-schedulepickups',
              disabled: this.$user.cannot(READ, this.$sdk.scheduledpickup) || this.$user.cannot(READ, 'menu_manage')
            }
          ]
        },
        {
          label: 'Sales',
          options: [
            {
              label: 'Dashboard',
              route: 'sales',
              disabled: this.$user.cannot(READ, 'menu_sales')
            },
            {
              label: 'To-Do',
              route: 'sales-todo',
              disabled: this.$user.cannot(READ, this.$sdk.account_event) || this.$user.cannot(READ, 'menu_sales')
            },
            {
              label: 'Accounts',
              route: 'sales-accounts',
              disabled: this.$user.cannot(READ, this.$sdk.account) || this.$user.cannot(READ, 'menu_sales')
            },
            {
              label: 'Opportunities',
              route: 'sales-opportunities',
              disabled: this.$user.cannot(READ, this.$sdk.account_lead) || this.$user.cannot(READ, 'menu_sales')
            },
            {
              label: 'Budgets',
              route: 'sales-budgets',
              disabled: this.$user.cannot(READ, this.$sdk.budget) || this.$user.cannot(READ, 'menu_sales')
            },
            {
              label: 'Pipes',
              route: 'sales-pipes',
              disabled: this.$user.cannot(READ, this.$sdk.account_lead) || this.$user.cannot(READ, 'menu_sales')
            }
          ]
        },
        {
          label: 'Freight',
          options: [
            {
              label: 'Dashboard',
              route: 'freight',
              disabled: this.$user.cannot(READ, 'menu_freight')
            },
            {
              label: 'Consignments (New)',
              route: 'freight-consignments-v3',
              disabled: this.$user.cannot(READ, this.$sdk.consignment) || this.$user.cannot(READ, 'menu_freight')
            },
            {
              label: 'Consignments',
              route: 'freight-consignments',
              disabled: this.$user.cannot(READ, this.$sdk.consignment) || this.$user.cannot(READ, 'menu_freight')
            },
            {
              label: 'Tracking',
              route: 'freight-tracking',
              disabled: this.$user.cannot(READ, 'tracking') || this.$user.cannot(READ, 'menu_freight')
            },
            {
              label: 'Quote',
              route: 'freight-quote',
              disabled: this.$user.cannot(READ, 'legacy_rates_ratesCustomerQuote') || this.$user.cannot(READ, 'menu_freight')
            }
          ]
        },
        {
          label: 'Billing',
          options: [
            {
              label: 'Dashboard',
              route: 'billing',
              disabled: this.$user.cannot(READ, 'menu_billing')
            },
            {
              label: 'Invoices',
              route: 'billing-invoices',
              disabled: this.$user.cannot(READ, 'legacy_invoicing_invoices') || this.$user.cannot(READ, 'menu_billing')
            },
            {
              label: 'Generate Invoice',
              route: 'billing-generate',
              disabled: this.$user.cannot(READ, 'legacy_invoicing_generateInvoices') || this.$user.cannot(READ, 'menu_billing')
            },
            {
              label: 'Reconciliation',
              route: 'billing-reconciliation',
              disabled: this.$user.cannot(READ, 'legacy_invoicing_reconciliation') || this.$user.cannot(READ, 'menu_billing')
            },
            {
              label: 'Carrier Invoices',
              route: 'billing-carrier',
              disabled: this.$user.cannot(READ, 'legacy_invoicing_invoices') || this.$user.cannot(READ, 'menu_billing')
            },
            {
              label: 'Carrier Credits',
              route: 'billing-credits',
              disabled: this.$user.cannot(READ, 'legacy_invoicing_manageCredits') || this.$user.cannot(READ, 'menu_billing')
            }
          ]
        },
        {
          label: 'Reports',
          options: [
            {
              label: 'Freight',
              route: 'reports',
              disabled: this.$user.cannot(READ, 'legacy_reports_freight') || this.$user.cannot(READ, 'menu_reports')
            },
            {
              label: 'Invoicing',
              route: 'reports-invoice',
              disabled: this.$user.cannot(READ, 'legacy_reports_invoicing') || this.$user.cannot(READ, 'menu_reports')
            },
            {
              label: 'Accounts (Old)',
              route: 'reports-legacy-accounts',
              disabled: this.$user.cannot(READ, 'legacy_reports_freight') || this.$user.cannot(READ, 'menu_reports')
            },
            {
              label: 'Freight (Old)',
              route: 'reports-legacy-freight',
              disabled: this.$user.cannot(READ, 'legacy_reports_freight') || this.$user.cannot(READ, 'menu_reports')
            },
            {
              label: 'Sales (Old)',
              route: 'reports-legacy-sales',
              disabled: this.$user.cannot(READ, 'legacy_reports_freight') || this.$user.cannot(READ, 'menu_reports')
            },
            {
              label: 'Invoicing (Old)',
              route: 'reports-legacy-invoice',
              disabled: this.$user.cannot(READ, 'legacy_reports_invoicing') || this.$user.cannot(READ, 'menu_reports')
            }
          ]
        },
        {
          label: 'Configuration',
          options: [
            {
              label: 'Locations',
              route: 'configuration',
              disabled: this.$user.cannot(READ, 'dictionary_location') || this.$user.cannot(READ, 'menu_configuration')
            },
            {
              label: 'Assets',
              route: 'configuration-assets',
              disabled: this.$user.cannot(READ, this.$sdk.asset) || this.$user.cannot(READ, 'menu_configuration')
            }
          ]
        }
      ]
    }
  },
  computed: {
    READ () {
      return READ
    }
  },
  created () {
    if (!this.$_.get(this.layout, 'cacheTime')) {
      this.layout.cacheTime = 3
    }
    if (!this.$_.get(this.layout, 'consignmentPagePreferences')) {
      this.layout.consignmentPagePreferences = [ 'header', 'information', 'items', 'pricing and margin', 'tracking', 'tracking errors', 'manifest pricing', 'quoted pricing' ]
    }
    if (typeof this.$_.get(this.layout, 'consignmentLinkPopoverEnabled') !== 'boolean') {
      this.$set(this.layout, 'consignmentLinkPopoverEnabled', true)
    }
    if (typeof this.$_.get(this.layout, 'keyboardShortcutsEnabled') !== 'boolean') {
      this.$set(this.layout, 'keyboardShortcutsEnabled', false)
    }
    if (!this.$_.get(this.layout, 'tableSize')) {
      this.layout.tableSize = 'default'
    }
  }
}
</script>
